interface Params {
    title: string;
    width: number;
    height: number;
}
interface PopupParamsInterface {
    hib: Params;
    contact: Params;
}

export const popupParams: PopupParamsInterface = {
    hib: {
        title: 'Hotelinfobox',
        width: 900,
        height: 808,
    },
    contact: {
        title: 'Kontakt',
        width: 1024,
        height: 808,
    },
};
